import HowToContent from "@SearchResults/features/staticContent/features/singleModal/components/HowToContent";
import HowFarContent from "@SearchResults/features/staticContent/features/singleModal/components/HowFarContent";
import HowLongContent from "@SearchResults/features/staticContent/features/singleModal/components/HowLongContent";
import HowMuchContent from "@SearchResults/features/staticContent/features/singleModal/components/HowMuchContent";
import HowManyTripsContent
    from "@SearchResults/features/staticContent/features/singleModal/components/HowManyTripsContent";
import GenericTipsContent
    from "@SearchResults/features/staticContent/features/singleModal/components/GenericTipsContent";
import TipsPerTransportTypeContent
    from "@SearchResults/features/staticContent/features/singleModal/features/tips/components/TipsPerTransportTypeContent";
import CompaniesOperatingContent
    from "@SearchResults/features/staticContent/features/singleModal/components/CompaniesOperatingContent";
import HowManyCustomersContent
    from "@SearchResults/features/staticContent/features/singleModal/components/HowManyCustomersContent";
import useSearchResults from "@SearchResults/hooks/useSearchResults";
import getTranslationFromTransportType
    from "@SearchResults/features/staticContent/functions/getTranslationFromTransportType";
import allOperatorsForTypeGetter from "@SearchResults/features/staticContent/functions/allOperatorsForTypeGetter";
import getMinMaxPriceForType from "@SearchResults/features/staticContent/functions/getMinMaxPriceForType";
import getTravelTimes from "@SearchResults/features/staticContent/functions/getTravelTimes";
import {TransportTypesType} from "@SearchResults/types/TransportTypes.type";

interface SingleTransportTypeContentProps {
    transportType: TransportTypesType,
}

function SingleTransportTypeContent({transportType}: SingleTransportTypeContentProps) {
    const {data} = useSearchResults()

    const availableTransportation = getTranslationFromTransportType(transportType)

    const {
        result: {
            companies,
            params: {
                departureStation: {
                    cityName: departure,
                },
                destinationStation: {
                    cityName: destination,
                },
            },
            singleRoutes,
        },
        staticContent: {landDistance, airDistance, ticketsSoldByTransportType},
    } = data

    const {getAllOperatorsForType} = allOperatorsForTypeGetter(companies, singleRoutes)
    const {min: cheapestPrice} = getMinMaxPriceForType(singleRoutes[transportType])
    const {maxTime} = getTravelTimes(singleRoutes[transportType])

    const routeCount: number = singleRoutes[transportType].length

    const getDistance = () => {
        if (transportType === "ferry" || transportType === "plane") {
            return `${airDistance}km`
        }
        return `${landDistance ?? airDistance}km`
    }

    return (
        <>
            <HowToContent
                departure={departure}
                destination={destination}
                availableTransportation={availableTransportation}
            />
            <HowFarContent
                departure={departure}
                destination={destination}
                distance={getDistance()}
            />
            <HowLongContent
                departure={departure}
                destination={destination}
                availableTransportation={availableTransportation}
                durationMax={maxTime}
            />
            <HowMuchContent
                departure={departure}
                destination={destination}
                availableTransportation={availableTransportation}
                cheapestPrice={cheapestPrice}
            />
            <HowManyTripsContent
                departure={departure}
                destination={destination}
                transportType={transportType}
                routeCount={routeCount}
            />
            <GenericTipsContent
                departure={departure}
                destination={destination}
                availableTransportation={availableTransportation}
            />
            <TipsPerTransportTypeContent
                transportType={transportType}
            />
            <CompaniesOperatingContent
                departure={departure}
                destination={destination}
                availableTransportation={availableTransportation}
                operators={getAllOperatorsForType(transportType)}
            />
            <HowManyCustomersContent
                departure={departure}
                destination={destination}
                availableTransportation={availableTransportation}
                totalTicketsSold={ticketsSoldByTransportType[0]?.count ?? Math.floor(Math.random() * 1000) + 1000}
            />
        </>
    )
}

export default SingleTransportTypeContent